export const TippingPointTable_DE = {
  title: 'Die neun Klima-Kipppunkte',
  entries: [
    {
      number: 'A',
      id: 'amazonas',
      title: 'Amazonas-Regenwald',
      text: 'Zunehmende Dürre',
    },
    {
      number: 'B',
      id: 'arctic',
      title: 'Arktisches Meereis',
      text: 'Abnahme der Eismenge',
    },
    {
      number: 'C',
      id: 'atlantic',
      title: 'Zirkulation im Atlantik',
      text: 'Nachlassende Strömung',
    },
    {
      number: 'D',
      id: 'boreal',
      title: 'Wälder',
      text: 'Feuer und Schädlinge',
    },
    {
      number: 'E',
      id: 'coral',
      title: 'Korallenriffe',
      text: 'Weltweites Absterben',
    },
    {
      number: 'F',
      id: 'greenland',
      title: 'Grönländisches Eisschild',
      text: 'Beschleunigung des Eisschwunds',
    },
    { number: 'G', id: 'perma', title: 'Permafrost', text: 'taut auf' },
    {
      number: 'H',
      id: 'westantarctica',
      title: 'Westantarktisches Eisschild',
      text: 'Beschleunigung des Eisschwunds',
    },
    {
      number: 'I',
      id: 'eastantarctica',
      title: 'Ostantarktis',
      text: 'Beschleunigung des Eisschwunds',
    },
  ],
  source: (
    <>
      Quelle:{' '}
      <a href='https://www.nature.com/articles/d41586-019-03595-0'>Nature</a>
    </>
  ),
}
export const TippingPointTable_FR = {
  title: 'Les 9 points de basculement climatiques',

  entries: [
    {
      number: 'A',
      id: 'amazonas',
      title: 'Forêt amazonienne',
      text: 'Sécheresse croissante',
    },
    {
      number: 'B',
      id: 'arctic',
      title: 'Mer de glace arctique',
      text: 'Diminution de la quantité de glace',
    },
    {
      number: 'C',
      id: 'atlantic',
      title: "Circulation dans l'Atlantique",
      text: 'Diminution du courant',
    },
    {
      number: 'D',
      id: 'boreal',
      title: 'Forêts',
      text: 'Feu et parasites',
    },
    {
      number: 'E',
      id: 'coral',
      title: 'Récifs coralliens',
      text: 'Disparition mondiale',
    },
    {
      number: 'F',
      id: 'greenland',
      title: 'Calotte polaire du Groenland',
      text: 'Accélération du retrait de la glace',
    },
    { number: 'G', id: 'perma', title: 'Permafrost', text: 'Dégèle' },
    {
      number: 'H',
      id: 'westantarctica',
      title: "Calotte polaire de l'Antarctique Ouest",
      text: 'Accélération du retrait de la glace',
    },
    {
      number: 'I',
      id: 'eastantarctica',
      title: "Antarctique de l'Est",
      text: 'Accélération du retrait de la glace',
    },
  ],
  source: (
    <>
      Source:{' '}
      <a href='https://www.nature.com/articles/d41586-019-03595-0'>Nature</a>
    </>
  ),
}
